import { useMemo } from "react";
import { useUnits } from "./useUnits";

/**
 * Returns a memoized Map<unit_id, abbreviation> for inline unit display.
 */
export function useUnitMap(): Map<string, string> {
  const { data: units } = useUnits();
  return useMemo(() => {
    const map = new Map<string, string>();
    if (units) {
      for (const u of units) {
        map.set(u.id, u.abbreviation);
      }
    }
    return map;
  }, [units]);
}
